(() => {
  const filters = [...document.querySelectorAll(".blogArchive__selects .filterField")];
  if (!filters.length) return;

  filters.forEach((filter) => {
    filter.addEventListener("click", (event) => {
      const option = event.target.closest("button[data-filter-value]");
      if (!option) return;

      const input = filter.querySelector('input[type="hidden"]');
      input.value = option.dataset.filterValue;
      filter.open = false;
      input.form.requestSubmit();
    });

    filter.addEventListener("toggle", () => {
      if (!filter.open) return;
      filters.forEach((other) => {
        if (other !== filter) other.open = false;
      });
    });

    filter.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !filter.open) return;
      event.preventDefault();
      filter.open = false;
      filter.querySelector("summary").focus();
    });
  });

  document.addEventListener("click", (event) => {
    filters.forEach((filter) => {
      if (filter.open && !filter.contains(event.target)) filter.open = false;
    });
  });
})();
